import { AvailableOption } from "../../../../../types/prodcatBaseTypes";
import {
  CLICK_AND_COLLECT,
  HP_DELIVERY,
  LOCAL_COLLECTION,
  ONE_MAN_SPECIALIST_DELIVERY,
  ONE_MAN_STANDARD_DELIVERY,
  ONE_MAN_STANDARD_DELIVERY_64,
  SUPPLIER_DIRECT,
  SUPPLIER_DIRECT_3_DAY,
  SUPPLIER_DIRECT_4_DAY,
  SUPPLIER_DIRECT_5_DAY,
  TRADEPLACE,
  TWO_MAN_STANDARD_DELIVERY,
} from "./constants";

export const getDeliveryPrice = (option: AvailableOption) => {
  const { value, display } = option.price;
  if (parseFloat(value) > 0) return display;

  const { dmsId } = option.aliases;

  if (dmsId === TWO_MAN_STANDARD_DELIVERY) {
    return "From free";
  }

  if (
    dmsId === CLICK_AND_COLLECT ||
    dmsId === ONE_MAN_STANDARD_DELIVERY ||
    dmsId === ONE_MAN_STANDARD_DELIVERY_64 ||
    dmsId === SUPPLIER_DIRECT ||
    dmsId === SUPPLIER_DIRECT_3_DAY ||
    dmsId === SUPPLIER_DIRECT_4_DAY ||
    dmsId === SUPPLIER_DIRECT_5_DAY ||
    dmsId === LOCAL_COLLECTION ||
    dmsId === TRADEPLACE ||
    dmsId === ONE_MAN_SPECIALIST_DELIVERY ||
    dmsId === HP_DELIVERY
  ) {
    return "Free";
  }

  return "";
};
